'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('payment-list', {
      url: '/admin/payment/list',
      template: '<payment-list></payment-list>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/payment/list/payment-list.routes.js